import {Component, OnInit, ElementRef, Renderer2, ViewChild} from '@angular/core';
import {ConstantsService} from '@app/services/constants/constants.service';
import {ProventumApiService} from '@app/services/proventum-api.service';
import {Globals} from '@app/services/globals.service';
import {ActivatedRoute} from '@angular/router';
import {BridgeService} from '@app/services/bridge/bridge.service';
import {SidebarService} from "@components/my-web-desk/sidebar/sidebar.service";
import {SidebarComponent} from "@components/my-web-desk/sidebar/sidebar.component";
import {Subscription} from "rxjs";
import {reject} from "q";
import {ToastrService} from "ngx-toastr";

@Component({
    selector: 'app-my-web-desk',
    templateUrl: './my-web-desk.component.html',
    styleUrls: ['./my-web-desk.component.css']
})
export class MyWebDeskComponent implements OnInit {

    bridgeStack = '';
    creator_id = '';
    userData: any[] = [];

    sidebarState: boolean = true;
    loader = true;

    constructor(private globals: Globals,
                private proventumApiService: ProventumApiService,
                private constants: ConstantsService,
                private bridge: BridgeService,
                private route: ActivatedRoute,
                private sidebarSrv: SidebarService,
                public renderer: Renderer2,
                public sidebarService: SidebarService, private toastr: ToastrService
    ) {

        let creator = this.constants.creator_id;
        this.bridgeStack = 'testirfan';
        if (creator == '') {
            creator = this.route.snapshot.queryParamMap.get('creator');
            if (creator != null) {
                this.constants.setCreator(creator);
                localStorage.setItem('userId', creator);
            }
        }
    }

    appendClassesHandler() {}

    async ngOnInit() {

        this.bridge.sendDataViaBridge({
            bridgeStatus: 'open'
        });

        await this.getUserId();
        this.loader = false;
    }

    receiveMessage: any = (event: any) => {
        this.constants.setCreator(event.data.creator_id);
        this.creator_id = event.data.creator_id;
        sessionStorage.setItem('creator_id', this.creator_id);
    }

    sidebarHandler() {

    }

    getUserId() {
        return new Promise((resolve, reject) => {


            try {
                let id = Number(this.constants.creator_id);
                if (id == 0) {
                    let storedUserData = localStorage.getItem('userId');
                    if (storedUserData !== undefined && storedUserData != 'null') {
                        this.proventumApiService.getUser(storedUserData).subscribe(result => {
                            this.userData = result;
                            localStorage.setItem('userId', result.id);
                            this.constants.setUser(result);
                            this.constants.setCreator(result.id);
                            resolve();
                        }, error => (
                            reject(error)
                        ));
                    } else {
                        this.toastr.error('Došlo je do greške. Molimo Vas javite se korisničkoj podršci.');
                    }
                } else {

                    this.proventumApiService.getUser(id).subscribe(result => {
                        this.userData = result;
                        localStorage.setItem('userId', result.id);
                        this.constants.setUser(result);
                        resolve();
                    });
                }
            } catch (e) {

                reject(e);
            }


        })
    }

}
